// ===========================================
// Recent Notes Component
// ===========================================

import { useState } from 'react';
import { Alert, Box, Button, List, Skeleton } from '@mui/material';
import { ArrowForward as ArrowForwardIcon } from '@mui/icons-material';
import { Note } from '../../../api/notes.api';
import { Term } from '../../../api/admin.api';
import NoteItem from './NoteItem';
import AllNotesModal from './AllNotesModal';

interface Props {
  notes: Note[];
  isLoading: boolean;
  studentName: string;
  terms: Term[];
}

/**
 * Recent Notes for Student Tab
 */
export default function RecentNotes({ notes, isLoading, studentName, terms }: Props) {
  const [modalOpen, setModalOpen] = useState(false);

  if (isLoading) {
    return <Skeleton variant="rectangular" height={150} />;
  }

  const visibleNotes = notes.filter(
    (n) => n.visibility === 'PARENTS' || n.visibility === 'STUDENTS'
  );
  const recentNotes = visibleNotes
    .sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime())
    .slice(0, 5);

  if (recentNotes.length === 0) {
    return <Alert severity="info">No notes from teachers yet.</Alert>;
  }

  return (
    <Box>
      <List disablePadding>
        {recentNotes.map((note) => (
          <NoteItem key={note.id} note={note} />
        ))}
      </List>
      <Button size="small" endIcon={<ArrowForwardIcon />} onClick={() => setModalOpen(true)}>
        View All ({visibleNotes.length})
      </Button>
      <AllNotesModal
        open={modalOpen}
        onClose={() => setModalOpen(false)}
        notes={notes}
        studentName={studentName}
        terms={terms}
      />
    </Box>
  );
}
